<div style="max-width: 100%;">
  <dx-data-grid class="h-100"
                [dataSource]="mediaFtpExportSettings"
                [remoteOperations]="false"
                [allowColumnReordering]="true"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                [showBorders]="true"
                [showColumnHeaders]="true"
                mode="multiple"
                (onRowUpdated)="onRowUpdated($event)"
                (onRowRemoved)="onRowRemoved($event)"
                (onRowInserted)="onRowInserted($event)"
                (onInitNewRow)="onInitNewRow($event)">

    <dxo-paging [pageSize]="50"></dxo-paging>
    <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-editing mode="cell" [allowUpdating]="isManager()" [allowDeleting]="isManager()" [allowAdding]="isManager()"> </dxo-editing>

    <dxi-column dataField="catalogId" caption="{{'Katalog'|translate}}">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-lookup [dataSource]="catalogs" valueExpr="id" displayExpr="catalogName"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="ftpServerId" caption="{{'Ftp Server'|translate}}">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-lookup [dataSource]="ftpServers" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="time" dataType="datetime" caption="{{'Uhrzeit'|translate}}"
                editCellTemplate="timeTemplate"
                showEditorAlways="true">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'timeTemplate'">
      <dx-date-box
        [(value)]="cellInfo.value"
        (onValueChanged)="cellInfo.setValue($event.value)"
        type="time"
        pickerType="list"
        [interval]="15"
      ></dx-date-box>
    </div>

    <dxi-column dataField="active" caption="{{ 'Aktiv' | translate }}" dataType="boolean"></dxi-column>

    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let column of 'detail'">
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Letzte Ausfuehrung' | translate }}</div>
          <div class="dx-field-value">
            <dx-date-box type="datetime"
                         [value]="column.data.lastRun"
                         [readOnly]="true">
            </dx-date-box>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label">{{ 'Letzter erfolgreicher Export' | translate }}</div>
          <div class="dx-field-value">
            <dx-date-box type="datetime"
                         [value]="column.data.lastSuccessfulRun"
                         [readOnly]="true">
            </dx-date-box>
          </div>
        </div>

        <div class="dx-field">
          <div class="dx-field-label"></div>
          <div class="dx-field-value">
            <dx-button style="text-align: right; float: right;" text="{{'Manuel ausführen'|translate}}" (onClick)="run(column.data)" icon="redo"> </dx-button>
          </div>
        </div>
      </div>
    </div>
  </dx-data-grid>
</div>
